import React, { useState } from 'react';
import axios from 'axios';
import './LearningGoals.css';

const LearningGoals = ({ userId, goals, onUpdate }) => {
  const [showAddGoal, setShowAddGoal] = useState(false);
  const [newGoal, setNewGoal] = useState({
    title: '',
    description: '',
    targetDate: '',
    topic: '',
    grade: 10
  });

  const handleAddGoal = async () => {
    try {
      await axios.post(
        '/api/metrics/goals',
        { ...newGoal, userId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      
      setShowAddGoal(false);
      setNewGoal({
        title: '',
        description: '',
        targetDate: '',
        topic: '',
        grade: 10
      });
      onUpdate();
    } catch (err) {
      console.error('Error adding goal:', err);
    }
  };

  const handleUpdateProgress = async (goalId, progress) => {
    try {
      await axios.put(
        `/api/metrics/goals/${userId}/${goalId}`,
        { progress },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      onUpdate();
    } catch (err) {
      console.error('Error updating goal:', err);
    }
  };

  const handleCompleteGoal = async (goalId) => {
    try {
      await axios.put(
        `/api/metrics/goals/${userId}/${goalId}`,
        { completed: true, progress: 100 },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      onUpdate();
    } catch (err) {
      console.error('Error completing goal:', err);
    }
  };

  return (
    <div className="learning-goals">
      <div className="goals-header">
        <h3>🎯 Learning Goals</h3>
        <button 
          className="add-goal-btn"
          onClick={() => setShowAddGoal(true)}
        >
          + Add New Goal
        </button>
      </div>
      
      {showAddGoal && (
        <div className="add-goal-form">
          <input 
            type="text"
            placeholder="Goal title"
            value={newGoal.title}
            onChange={(e) => setNewGoal({...newGoal, title: e.target.value})}
          />
          <textarea 
            placeholder="Description"
            value={newGoal.description}
            onChange={(e) => setNewGoal({...newGoal, description: e.target.value})}
          />
          <input 
            type="date"
            value={newGoal.targetDate}
            onChange={(e) => setNewGoal({...newGoal, targetDate: e.target.value})}
          />
          <input 
            type="text"
            placeholder="Topic"
            value={newGoal.topic}
            onChange={(e) => setNewGoal({...newGoal, topic: e.target.value})}
          />
          <select 
            value={newGoal.grade}
            onChange={(e) => setNewGoal({...newGoal, grade: parseInt(e.target.value)})}
          >
            <option value="10">Grade 10</option>
            <option value="11">Grade 11</option>
            <option value="12">Grade 12</option>
          </select>
          <div className="form-actions">
            <button onClick={handleAddGoal}>Save Goal</button>
            <button onClick={() => setShowAddGoal(false)}>Cancel</button>
          </div>
        </div>
      )}
      
      <div className="goals-list">
        {goals && goals.filter(g => !g.completed).map(goal => (
          <div key={goal._id} className="goal-card">
            <div className="goal-header">
              <h4>{goal.title}</h4>
              <span className="goal-date">
                Due: {new Date(goal.targetDate).toLocaleDateString()}
              </span>
            </div>
            <p className="goal-description">{goal.description}</p>
            <div className="goal-meta">
              <span className="goal-topic">{goal.topic}</span>
              <span className="goal-grade">Grade {goal.grade}</span>
            </div>
            <div className="progress-section">
              <div className="progress-bar">
                <div 
                  className="progress-fill"
                  style={{ width: `${goal.progress}%` }}
                />
              </div>
              <span className="progress-text">{goal.progress}%</span>
            </div>
            <div className="goal-actions">
              <input 
                type="range"
                min="0"
                max="100"
                value={goal.progress}
                onChange={(e) => handleUpdateProgress(goal._id, e.target.value)}
              />
              <button 
                className="complete-btn"
                onClick={() => handleCompleteGoal(goal._id)}
              >
                Mark Complete
              </button>
            </div>
          </div>
        ))}
        
        {(!goals || goals.filter(g => !g.completed).length === 0) && (
          <div className="empty-state">
            <p>No active learning goals</p>
            <p>Set a goal to track your progress!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LearningGoals;